"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIXED_INCOME_EXCESS_RATE = void 0;
/**
 * Rate applied to the excess of guaranteedJobIncome over minimumWageHVP
 * to compute jobFixedIncome.
 *
 * Formula:
 *   guaranteedJobIncome = minimumWageHVP * positionFactor
 *   jobFixedIncome = minimumWageHVP + (guaranteedJobIncome - minimumWageHVP) * FIXED_INCOME_EXCESS_RATE
 */
exports.FIXED_INCOME_EXCESS_RATE = 0.5;
